import type { EChartsOption } from 'echarts'

/**
 * Define chart options.
 */
export function defineChart<Params extends unknown[] = []>(
    cb: (...params: Params) => EChartsOption | undefined
) {
    return cb
}

/**
 * Export the chart legend.
 */
export function defaultExportedChart(obj: EChartsOption = {}, pieces?: any[]) {
    const { meta } = useMeta()

    return {
        ...obj,
        grid: obj.grid ?? {
            top: '10%',
            bottom: '20%'
        },
        visualMap: {
            left: 'center',
            itemSymbol: 'circle',
            bottom: '7.5%',
            orient: 'horizontal',
            itemWidth: 15,
            itemHeight: 15,
            itemGap: 10,
            textGap: 5,
            textStyle: {
                color: 'black',
                fontSize: 10
            },
            inverse: true,
            seriesIndex: -1,
            pieces:
                pieces ??
                meta.regions.map(({ id, name, color }) => ({
                    label: name,
                    value: id,
                    color
                }))
        }
    }
}

export async function getWatermark() {
    const { default: src } = await import('@/assets/watermark.svg')

    return new Promise<any>(resolve => {
        const watermarkRatio = 918 / 1176
        const watermarkWidth = 35
        const img = new Image()

        img.onload = () => {
            resolve({
                type: 'image',
                bottom: 10,
                right: 10,
                z: -10,
                style: {
                    image: img,
                    width: watermarkWidth,
                    height: watermarkWidth * watermarkRatio
                }
            })
        }

        img.src = src
    })
}

export function getSource(text: string, width: number) {
    return {
        type: 'text',
        silent: true,
        bottom: 10,
        left: 10,
        style: {
            fontSize: 10,
            color: '#000',
            text: text,
            overflow: 'break',
            width: width
        }
    }
}
